import React, { useState } from 'react';
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

const accordionData = [
{
id:1,
title:"Evaporative Condensers",
content:"These combine air and water, evaporating water sprayed over coils for cooling. Energy-efficient in hot areas, they serve commercial refrigeration but risk corrosion and need water treatment. Forced or induced draft fans enhance airflow"
},
{
id:2,
title:"Water-Cooled Condensers",
content:"Water absorbs heat from refrigerant in designs like shell-and-tube, tube-in-tube, or plate types. Common in large industrial setups, they offer high efficiency but require water supply and treatment to avoid scaling. Subtypes include shell-and-tube for high-capacity ammonia systems."
},
{
id:3,
title:"Air-Cooled Condensers",
content:"These use ambient air to cool refrigerant via finned coils, often with fans for forced convection. They suit small to medium systems like household refrigerators where water is unavailable. Maintenance is low, but efficiency drops in hot climates."
},
]

function Evaporative() {
     useGaspAnimations()
  const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };



    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
                    {/* <!--Start breadcrumb area-->      */}
            {/* <section className="breadcrumb-area">
                <div className="container text-center">
                    <h1>Evaporative Condenser</h1>
                </div>
            </section> */}
            {/* <!--End breadcrumb area--> */}

            {/* <!--Start breadcrumb bottom area--> */}
            {/* <section className="breadcrumb-botton-area">
                <div className="container">
                    <div className="left">
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                            <li><a href="services.html">Services</a></li>
                            <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                            <li className="active">Evaporative Condenser</li>
                        </ul>    
                    </div>
                </div>
            </section> */}
            {/* <!--End breadcrumb bottom area--> */}

            {/* <!--Start service single area--> */}
            <section id="service-single-area" className="smartphone-repair-area">
                <div className="container">
                    <div className="row">
                      <ProductFilter/>
                        <div className="col-md-9 col-sm-12 col-xs-12 pull-right">
                            <div className="service-single-content">
                                {/* <!--Start top content --> */}
                                <div className="row top-content">
                                    <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeLeft">
                                          {/* <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider> */}
                             <img src="assets/images/OurProducts/cooledcondenser.jpg" alt="Awesome Image"/>
                                    </div>
                                    <div className="col-md-7 col-sm-12 col-xs-12">
                                        <div className="textholder">
                                            <div className="title bdFadeUp sec-title">
                                                <h1><span>Cooling Condenser</span></h1>
                                            </div>
                                            <div className="text bdFadeUp">
                                                {/* <span>We Are professional. Reliable and Affortable</span> */}
                                                <p className="top">
                                                   Cooling condensers in refrigeration systems reject heat from high-pressure refrigerant vapor, condensing it into liquid. They are classified mainly by the cooling medium used. The primary types include air-cooled, water-cooled, and evaporative condensers.
                                                </p>

                                                     <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                                {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End top content --> */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="border"></div>
                                    </div>
                                </div>
                                {/* <!--Start middle content--> */}
                                <div className="row middle-content">
                                    <div className="col-md-7">
                                        <div className="text-holder">
                                            <div className="title bdFadeUp">
                                                <h2>Sub-categories</h2>
                                            </div>
                                            <div className="text bdFadeUp">
                                                {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                                <ul>
                                                     {accordionData.map(({ title}) => (
                                                    <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>{title}</li>
                                                     ))}
                                                </ul>
                                                    
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-5 bdFadeUp">
                                           <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider>
                                    </div> */}
                                </div>
                                {/* <!--End middle content--> */}
                                {/* <!--Start bottom content--> */}
                              <div className="row bottom-content">
                                    <div className="col-md-12">
                                        <div className="title bdFadeUp">
                                                <h2>Sub-category Descriptions</h2>
                                            </div>
                                        <div className="accordion-box bdFadeUp">
                                            {accordionData.map(({ id, title, content }) => (
                                            <>
                                            {/* <!--Start single accordion box--> */}
                                            <div className="accordion accordion-block" key={id}>
                                                <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                                {openSections[id] && (
                                                <div className="accord-content collapsed">
                                                    <p>
                                                    {content}
                                                    </p>
                                                </div>
                                                )}
                                            </div>
                                            {/* <!--End single accordion box-->  */}
                                            </>
                                            ))}
                                    </div>
                                </div>
                                </div>
                                {/* <!--End bottom content--> */}
                                {/* <!--Start Consultation form--> */}
                               
                                {/* <!--End Consultation form--> */}
                            </div>
                        </div>
              
                        
                    </div>
                </div>    
            </section>
            {/* <!--End service single area--> */}
 <MakeAppoinment/>
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Evaporative;

